import * as React from 'react';

import type { IconProps } from '../types';

const StatusAlert = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <path
          fill="hsl(var(--twc-status-icon-alert))"
          d="M7.47058 2.60692C7.71038 2.21566 8.28961 2.21566 8.52941 2.60692L13.613 10.9013C13.8599 11.3042 13.5635 11.8167 13.0836 11.8167H2.91642C2.43652 11.8167 2.14009 11.3042 2.387 10.9013L7.47058 2.60692Z"
        />
      </svg>
    );
  }
);

StatusAlert.displayName = 'StatusAlert';

export { StatusAlert };
